import { render, staticRenderFns } from "./myOffering.vue?vue&type=template&id=38c1d3a1&scoped=true"
import script from "./myOffering.vue?vue&type=script&lang=js"
export * from "./myOffering.vue?vue&type=script&lang=js"
import style0 from "./myOffering.vue?vue&type=style&index=0&id=38c1d3a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c1d3a1",
  null
  
)

export default component.exports